import { AxiosResponse } from "axios";

import client from "libs/HttpClient";

/**
 * Represents the data required for admin login.
 */
interface LoginData {
  email: string;
  password: string;
}

/**
 * Service class for handling administrative authentication.
 */
class AdminAuthService {
  /**
   * Performs admin login using the provided login data.
   *
   * @param loginData - The data containing email and password for authentication.
   * @returns A Promise that resolves to the AxiosResponse containing authentication results.
   */
  static login(loginData: LoginData): Promise<AxiosResponse<any, any>> {
    return client.post("admin/auth/login", loginData);
  }
}

export { AdminAuthService };
